import React from 'react';
import LogTable from 'components/atoms/log-table';
import { useHoldingStatusLog } from 'infrastructure/hooks/logs/use-holding-status-log';
import useUpdateEffect from 'infrastructure/hooks/utils/use-update-effect';

interface IPatientHoldingStatusLogProps {
  patientGuid: string;
  dateRange?: [Date, Date];
}

const PatientHoldingStatusLog: React.FC<IPatientHoldingStatusLogProps> = (
  props,
) => {
  const { patientGuid, dateRange } = props;

  const { loading, meta, items, setMeta } = useHoldingStatusLog({
    patientGuid,
    meta: {
      dateRange,
    },
  });

  const onChangePage = (page: number) => {
    setMeta({
      ...meta,
      page,
      dateRange,
    });
  };

  useUpdateEffect(() => {
    setMeta({
      ...meta,
      page: 1,
      dateRange,
    });
  }, [dateRange]);

  return (
    <LogTable
      dataCy="patient-holding-status-log-table"
      items={items}
      loading={loading}
      pagination={{
        current: meta.page,
        pageSize: meta.items,
        total: meta.totalCount,
        position: ['bottomCenter'],
      }}
      onChangePage={onChangePage}
    />
  );
};

export default PatientHoldingStatusLog;
